import React from 'react';
import { Link } from "react-router-dom";
import {doLogout} from '../views/logout';
import BaseClass from '../common/baseClass';
import { connect } from "react-redux";
import { wishListSelector } from "../../redux/selectors";
import TooltipCart from '../views/TooltipCart';

const env = require("../../config.js").default;
const common = require('../common/common');

export class LanguageButton extends React.Component {
  componentDidMount(){
    const $ = window.$;
    $(document).ready(() => {changeDropdownPosition();});
    $(window).on("resize", () => {changeDropdownPosition();});
  }

  renderLingue(){
    if(!window.cc || !window.cc.languages)
      return (<></>);
    var linguaAttiva = '';
    if(window.cc.languages.indexOf(common.getLanguage()) > -1)
      linguaAttiva = common.getLanguage();
    else
      linguaAttiva = 'en';

    return window.cc.languages.map(function(index, key){
      return(
        <li role="presentation" className={"language-" + index + (index === linguaAttiva ? " currentLanguage" : "")} key={key}>
          <a href="/#" role="menuitem" onClick={(e) => {e.preventDefault(); common.setLanguage(index)}} title={common.getTrad("lingua_" + index.toUpperCase())}>
            <img className="bandiere_icone" src={env.STATIC +  "images/bandiere/" + index + ".svg"} alt={common.getTrad("lingua_" + index.toUpperCase())} title={common.getTrad("lingua_" + index.toUpperCase())}/> {common.getTrad("lingua_" + index.toUpperCase())}
          </a>
        </li>
      )
    });
  }

  render(){
    return(
      <li id="li-portal-language" className="menu_drop dropdown-toggle sw-language">
		    <span id="lang_dropdown">
	        <i className="fas fa-globe-americas"></i> <sub><i className="fas fa-caret-down"></i></sub>
		    </span>
    		<ul id="portal-languageselector" className="dropdown-content" role="menu" aria-labelledby="lang_dropdown">
          {this.renderLingue()}
    		</ul>
    	</li>
    )
  }
}

export class UserButton extends React.Component {
  constructor(props){
    super(props);
    this.state={};
    this.state.userInfo={};
  }
  componentWillMount(){
    this.setState({userInfo: window.cc.userInfo});
  }
  render(){
    return(
      env.BACKEND_LOGIN_GRANT_TYPE !== 'client_credentials' ?
        <li className="menu_drop dropdown-toggle sw-user">
  		    <span id="portal-personaltools-header">
            <i className="fas fa-user" style={{float: "left"}}></i>&nbsp;
      			<span id="myUsername" className="truncateWords">&nbsp;{this.state.userInfo ? this.state.userInfo.GBWUSER.RCLIE : ""}</span>
      			<sub><i className="fas fa-caret-down"></i></sub>
      		</span>
      		<ul id="portal-personaltools-menu" className="dropdown-content" role="menu" aria-labelledby="portal-personaltools-header">
      			<li role="presentation" id="personaltools-logout">
      				<a href="/#" onClick={(e) =>{doLogout(true);e.preventDefault();}}>{common.getTrad("Esci")}</a>
      			</li>
      		</ul>
      	</li>
      :
        <></>
    )
  }
}

export class WishListButton extends BaseClass {
  constructor(props){
    super(props);
    this.state = { showTooltipCart: false };
  }

  navInternoClick = () => {
    this.closeTooltipCart();
    // this.props.openFunction();
    menuHomeOpen();
  }
  
  closeTooltipCart = () => {
    const $ = window.$;
    const tooltip = $('.tooltip_cart');
    //se loader visibile non smonto Tooltip
    if ($('#conteiner_loader').is(':visible'))
      return false;

    if (tooltip.is(':visible') && this.state.showTooltipCart) {
      $('.tooltip_cart').fadeOut(() => {
        this.setState({ showTooltipCart: false });      
      });
    }
    else if (this.state.showTooltipCart)
      this.setState({ showTooltipCart: false });
  }

  openTooltipCart = () => {
    const $ = window.$;
    const tooltip = $('.tooltip_cart');
    if (!tooltip.is(':visible'))
      this.setState({ showTooltipCart: true });
  }

  componentWillMount(props){
    this.updateStateWithStoreProps();
  }

  componentWillReceiveProps(nextProps){
    this.updateStateWithStoreProps(nextProps);
    this.setState({rerender: Math.random()});
  }

  componentDidUpdate(props){
    this.updateStateWithStoreProps();
  }
  render() {
    const $ = window.$;
    return(
      <li className="rounded-circle sw-wish-list" onClick={this.navInternoClick} onMouseEnter={() => this.openTooltipCart()} onMouseLeave={() => this.closeTooltipCart()}>
        <span style={{position: "relative"}}>
          <i className="fas fa-shopping-cart"></i>
          {this.state.dataList.wishList !== undefined && this.state.dataList.wishList !== null && this.state.dataList.wishList.length > 0 ?
            <sup className="notify_counter wishListNotifiy">
              <i className="fas fa-check-circle justWished"></i>
            </sup>
            :
            <></>
          }
          {this.state.showTooltipCart && !$('.Content_nav_interno').hasClass('open') && !$('.tooltip_cart').is(':visible') && (
            <div className="tooltip-wrapper" onClick={(e) => e.stopPropagation()}>
              <TooltipCart handleClose={this.closeTooltipCart} />
            </div>
              )}
        </span>
      </li>
    )
  }
}
const mapStateToProps = state => {
  const store = wishListSelector(state);
  return { store };
}
export default connect(mapStateToProps)(WishListButton);


export const menuHomeOpen = (open=true)=>{
  const $ = window.$;

  if($('.Content_nav_interno').hasClass('open')){
    $("#body").removeClass('no_scrollbar');
    $('.Content_nav_interno').removeClass('fadeInDown');
    $('.Content_nav_interno').addClass('fadeOutUp');
    setTimeout(function(){$('.Content_nav_interno').removeClass('open');}, 300);
    var menuAperti = $(document).find(".elenco_voci.open");
    var menuApertiButtons = $(document).find(".bottoni_menu_link.submenuOpen");
    if(menuApertiButtons.length > 0){
      $(menuAperti).each(function(){
        $(this).height(0);
        $(this).removeClass("flipInX");
        $(this).addClass("flipOutX");
        $(this).removeClass("open");
      });
      $(menuApertiButtons).each(function(){
        $(this).removeClass("submenuOpen");
        $(".submenuPlaceHolder").height(0);

      });
      //$(".submenuPlaceHolder").hide();
    }

  }else{
    if(open){
      $('.Content_nav_interno').removeClass('fadeOutUp');
      $('.Content_nav_interno').addClass('open fadeInDown');
      $("#body").addClass('no_scrollbar');
    }
  }
}

function changeDropdownPosition(){
  const $ = window.$;
  var top = $("#menu_fisso").position().top + $("#menu_fisso").height();
  $("#portal-top .dropdown-content").css("top", top + "px");
}
